export const LEQ_updatePreviousScreenReducer = {
  LEQ_updatePreviousScreen: (state, action) => {
    state.previousScreen = action.payload;
  },
};
